import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { FRODO_DEVICE_SN } from 'src/environments/runtime';

import { Device, DeviceHardwareInfo, IHDspace } from '../../interfaces/IHDspace';
import { DEVICE_UPDATE_EVENT } from '../../utils/constants';
import { EndpointService } from '../endpoint/endpoint.service';
import { HelmsdeepService } from '../helmsdeep/helmsdeep.service';
import { SocketService } from '../socket/socket.service';
@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private serialNum: BehaviorSubject<string> = new BehaviorSubject<string>(FRODO_DEVICE_SN);
  private spaces: Array<IHDspace>;
  private hardwareInfo: DeviceHardwareInfo;

  constructor(
    private helmsdeepService: HelmsdeepService,
    private socketService: SocketService,
    private endpointService: EndpointService
  ) {
    this.helmsdeepService.getMyDevice({ includeSpaces: true }).subscribe((device: Device) => {
      this.serialNum.next(device.serialNum);
      this.spaces = device.spaces;
      this.hardwareInfo = device.hardwareInfo;
    });

    this.socketService.setSocketHost(this.endpointService.getGandalfUrl());
    this.socketService.socket.on(DEVICE_UPDATE_EVENT, (data) => {
      const parsedData = JSON.parse(data.msg.body);
      this.serialNum.next(parsedData[0].serialNum);
    });
  }

  get getSerialNum() {
    return this.serialNum;
  }

  getSpaceByPosition(position) {
    let space;
    if (this.spaces) {
      space = this.spaces.filter((space) => space.hardwareInfo.position === position)[0];
    }
    return space;
  }

  get getHardwareInfo() {
    return this.hardwareInfo;
  }
}
